// const cryptico = require("node-cryptico");
// const { MD5: md5 } = require("node-cryptico/lib/hash");

const CHARGE_ENCRYPTION_KEY = process.env.CHARGE_ENCRYPTION_KEY;

const asciiSanitize = (function __asciiSanitize__() {
  const NON_ASCII_REGEX = /[^\x00-\x7F]/;

  return function _sanitizer(value) {
    return NON_ASCII_REGEX.test(value)
      ? encodeURIComponent(value)
      : value;
  };
})();

function __stringify__(data) {
  return JSON.stringify(data, (key, value) => {
    if (key === 'meta') {
      try {
        value = value.map(v => ({
          metaname: asciiSanitize(v.metaname),
          metavalue: asciiSanitize(v.metavalue)
        }));
      } catch (e) {}
    }

    else if (key === 'QUERY_STRING_DATA') {
      try {
        value = Object.keys(value).reduce((data, key) => {
          data[key] = asciiSanitize(value[key]);
          return data;
        }, {});
      } catch (e) {}
    }

    return value;
  });
}

function __encrypt__(data) {
  return cryptico.encrypt(
    typeof data === 'string' ? data : __stringify__(data),
    CHARGE_ENCRYPTION_KEY
  ).cipher;
}

function md5(data) {
  return cryptico.publicKeyID(
    typeof data === 'string' ? data : JSON.stringify(data)
  );
}

// module.exports = __encrypt__;
// module.exports.md5 = md5;

export { md5 };
export default __encrypt__;
